import styled from 'styled-components';

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: ${(p) => p.theme.sellerTheme.primary.value};
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  h1 {
    font-size: 6rem;
    font-weight: 500;
    margin: 0;
    color: ${(p) => p.theme.sellerTheme.primary.safeColorInsideContainer};
  }
  p {
    font-size: 3rem;
    color: ${(p) => p.theme.sellerTheme.primary.safeColorInsideContainer};
  }
`;

export const Button = styled.button`
  background-color: ${(p) =>
    p.theme.sellerTheme.primary.safeColorInsideContainer};
  color: ${(p) => p.theme.sellerTheme.primary.value};
  border: none;
  border-radius: 4px;
  width: 20rem;
  padding: 1.5rem 1rem;
  margin: 1rem;
  cursor: pointer;
  &:hover {
    background-color: ${(p) =>
      p.theme.sellerTheme.primary.safeColorInsideContainer};
    opacity: 0.8;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
